export const api = {
  rawList: '/nhf-nhmodel/formulamodelraw/pageWithRawInfo',     // 原料
  addRaw: '/nhf-nhmodel/formulamodelraw/save',      // 新建原料
  updateRaw: '/nhf-nhmodel/formulamodelraw/update', // 修改原料
  removeRaw: '/nhf-nhmodel/formulamodelraw/remove', // 删除原料

  modelList: '/nhf-nhmodel/formulamodel/UserInfopage', // 带编辑用户和动物类型
  modelDetail: '/nhf-nhmodel/formulamodel/detail',     // 模型详情
  createModel: '/nhf-nhmodel/formulamodel/save',          // 新增模型
  removeModel: '/nhf-nhmodel/formulamodel/remove',     // 删除模型
  updateModel: '/nhf-nhmodel/formulamodel/update',     // 修改模型

  nutritionList: '/nhf-nhmodel/formulamodelnutrition/pageWithNutritionInfo',      // 营养表列表
  newNutrition: '/nhf-nhmodel/formulamodelnutrition/save',       // 新增营养表
  updateNutrition: '/nhf-nhmodel/formulamodelnutrition/update',  // 新增营养表
  removeNutrition: '/nhf-nhmodel/formulamodelnutrition/remove',   // 删除营养表
  coreRaw: '/nhf-core-data/raw/rawUserPage',

  coreNutrition:'/nhf-nhmodel/formulamodelnutrition/pageWithOutNutritionExist',
  coreRawList:'/nhf-nhmodel/formulamodelraw/pageWithoutExist'
  
}
export const modelMixins = {
  data() {
    return {
      raw:[],
      model: {
        records:[]
      },
      modelDetail: {},
      nutrition: [],
      modelLoading: false,
      updateLoading:false,
      selectedRowKeys:[],
      selectedRows:[],
      pagination: {},
      currentPage: {
        size: 20,
        current:1
      }
    }
  },
  methods: {
    // 模型列表
    async coreNutrition(arg = {}) {
      try {
        this.loading = true
        const res = await this.$getForm(api.coreNutrition, { ...this.pageSetting(), ...arg })
        this.nutrition = res.data
        this.setPager(res.data)
        return res.data
      } catch (error) {
        return error
      } finally {
        this.loading = false
      }
    },
    // 模型列表
    async coreRawList(arg = {}) {
      try {
        this.loading = true
        const res = await this.$getForm(api.coreRawList, { ...this.pageSetting(), ...arg })
        this.raw = res.data
        this.setPager(res.data)
        return res.data
      } catch (error) {
        return error
      } finally {
        this.loading = false
      }
    },
    // normal page
    pageSetting() {
      return {
        size: 20, current: 1
      }
    },
    // 模型列表
    async getModelList(arg = {}) {
      try {
        this.modelLoading = true
        const res = await this.$get(api.modelList, { ...this.pageSetting(), ...arg })
        this.model = res.data
        this.setPager(res.data)
        return res.data
      } catch (error) {
        return error
      } finally {
        this.modelLoading = false
      }
    },

    // 新增模型
    async getModelDetail(params) {
      try {
        this.createModelLoaidng = true
        const res = await this.$getForm(api.modelDetail, params)
        // return this.getModelList()
        this.modelDetail = res.data
        return res.data
      } catch (error) {
        error.msg && this.$message.error(error.msg)
      } finally {
        this.createModelLoaidng = false
      }
    },

    async createModel(params) {
      try {
        this.createModelLoaidng = true
        const res = await this.$post(api.createModel, params)
        this.$message.success(res.msg)
        return this.getModelList()
      } catch (error) {
        error.msg && this.$message.error(error.msg)
      } finally {
        this.createModelLoaidng = false
      }
    },
    
    // 编辑模型
    async updateModel(params) {
      try {
        this.createModelLoaidng = true
        const res = await this.$post(api.updateModel, params)
        this.$message.success(res.msg)
        return this.getModelList({...this.currentPage})
      } catch (error) {
        error.msg && this.$message.error(error.msg)
      } finally {
        this.createModelLoaidng = false
      }
    },

    // 删除模型
    async remvoeModel(data) {
      try {
        const res = await this.$postForm(api.removeModel, data)
        this.$message.success(res.msg)
        return this.getModelList()
      } catch (error) {
        error.msg && this.$message.error(error.msg)
      }
    },

    // 原料列表
    async getRawList(arg = {}) {
      try {
        const res = await this.$getForm(api.rawList, { ...this.pageSetting(), ...arg }) 
        this.raw = res.data
        this.setPager(res.data)
        return res.data
      } catch (error) {
        error.msg && this.$message.error(error.msg)
      }
    },
    
    // 添加原料
    async modelAddRaw(arg = {}) {
      try {
        const res = await this.$post(api.addRaw,arg) 
        // this.raw = res.data
        this.$message.success(res.msg)
      } catch (error) {
        error.msg && this.$message.error(error.msg)
      }
    },

    // 移出原料
    async removeRaw(arg = {}) {
      try {
        const res = await this.$postForm(api.removeRaw,arg) 
        this.$message.success(res.msg)
        return res
      } catch (error) {
        error.msg && this.$message.error(error.msg)
      }
    },

    // 原料更新
    async updateRaw(arg = {}) {
      try {
        this.updateLoading = true
        const res = await this.$post(api.updateRaw, arg)
        this.$message.success(res.msg)
        this.updateLoading = false
        return res
      } catch (error) {
        error.msg && this.$message.error(error.msg)
      } finally {
        this.updateLoading = false
      }
    },

    async getNutritionList(arg = {}) {
        try {
        this.nutritionLoading = true
        const res = await this.$get(api.nutritionList, {...this.pageSetting(), ...arg })
        this.nutrition = res.data
        this.setPager(res.data)
        return res.data
      } catch (error) {
        return error
      } finally {
        this.nutritionLoading = false
      }
    },

    async addNutrition(arg = {}) {
       try {
        const res = await this.$post(api.newNutrition,arg) 
        this.$message.success(res.msg)
      } catch (error) {
        error.msg && this.$message.error(error.msg)
      }
    },

    async updateNutrition(arg = {}) {
      try {
        this.updateLoading = true
        const res = await this.$post(api.updateNutrition, arg)
        this.$message.success(res.msg)
        this.updateLoading = false
        return res
      } catch (error) {
        error.msg && this.$message.error(error.msg)
      } finally {
        this.updateLoading = false
      }
    },
      
    async removeNutrition(arg = {}) {
      try {
        const res = await this.$postForm(api.removeNutrition, arg) 
        this.$message.success(res.msg)
        return res
      } catch (error) {
        error.msg && this.$message.error(error.msg)
      }
    },

    // 设置分页
    setPager(res){
      const {total,current,size:pageSize}= res
      this.pagination = {
        ...this.pagination,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        pageSize,
        total,
        current,
        showSizeChanger: true,
        showTotal: (total) => (<div style="flex:1;">共{total}条记录</div>)
      }
      this.currentPage = {
        current,
        size:pageSize
      }
    },

    cleanSelect(){
      this.selectedRowKeys=[]
      this.selectedRows=[]
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      console.log(selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
      let arr = [...this.selectedRows, ...selectedRows]
      this.selectedRows = selectedRowKeys.map(i => {
        return arr.filter(item=>item.id === i)[0]
      })
      console.log(  this.selectedRows )
    },

  }
}